import { Injectable } from '@angular/core';

export interface StoredFilterOptions {
  postFilters?: Record<string, any>;
  formFilters?: Record<string, any>;
  tags?: Record<string, any>;
  fromDate?: unknown;
  toDate?: unknown;
  /** Texto de búsqueda de la lista de informes (toolbar). */
  searchQuery?: string;
}

@Injectable({
  providedIn: 'root'
})
export class FilterService {
  private byFormId: Record<number, StoredFilterOptions> = {};

  getForForm(formId: number): StoredFilterOptions | null {
    if (!formId) {
      return null;
    }
    return this.byFormId[formId] ?? null;
  }

  setForForm(formId: number, data: StoredFilterOptions): void {
    if (formId) {
      this.byFormId[formId] = data;
    }
  }

  clearForForm(formId?: number): void {
    if (formId != null) {
      delete this.byFormId[formId];
      return;
    }
    this.byFormId = {};
  }

  clearAll(): void {
    this.byFormId = {};
  }

  /** @deprecated Use getForForm(formId) */
  get filterOptions(): StoredFilterOptions {
    const ids = Object.keys(this.byFormId).map(Number);
    if (!ids.length) {
      return {};
    }
    return this.byFormId[ids[ids.length - 1]];
  }

  /** @deprecated Use setForForm / clearAll */
  set filterOptions(data: StoredFilterOptions | [] | Record<string, never>) {
    if (Array.isArray(data) || !data || Object.keys(data).length === 0) {
      this.clearAll();
    }
  }
}
